export default __webpack_public_path__ + "static/media/c.75d13fbd.png";